// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1149c","title":"Images45_title__1cVdk","images":"Images45_images__2qT9S"};